import ImageTitle from "src/components/articledisplays/ImageTitle";
import { ASPECT_2_1 } from "src/components/articledisplays/ImageTitleAspect2_1";
import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import { ArticleBlockSponsorProps } from "src/components/forsiden/ArticleBlockV2";
import VerticalArticleList from "src/components/forsiden/VerticalArticleList";
import { isAdContent } from "src/components/forsiden/utilsv2";
import SomeFacebookSquareLogoSvg from "src/components/svg/SomeFacebookSquareLogoSvg";
import SomeInstagramSquareLogoSvg from "src/components/svg/SomeInstagramSquareLogoSvg";
import SomeTikTokLogoSvg from "src/components/svg/SomeTikTokLogoSvg";
import TopOfPageSponsor from "src/components/takoversponsor/TopOfPageSponsor";
import styles from './ArticlesAndList.module.css';
import IFilmnytt from "src/lib/types/Filmnytt";
import { IFilmomtale } from "src/lib/types/Filmomtale";
import { ThemeValues, type IArticlesAndList } from "src/lib/types/IForsidenV2";

//#region [Props]
type ArticlesAndListProps = {
    block: IArticlesAndList;
} & ArticleBlockSponsorProps;
//#endregion

const SIZES = `(min-width: 1641px) 518px, ((max-width: 1640px) and (min-width: 550px)) 50%, 50vw`;

//#region [Component]
export default function ArticlesAndList({ block, sponsorClickUrl, sponsorTopImageDesktop, sponsorTopImageMobile }: ArticlesAndListProps) {
    return <>
        {(sponsorTopImageMobile?.length ?? 0) > 0 && <TopOfPageSponsor className={styles.STopOfPageSponsor} clickUrl={sponsorClickUrl} mobileImages={sponsorTopImageMobile} />}
        <div className={styles.SArticleRowBlock}>
            <div>
                <div className={styles.SArticleBlockHeader}>
                    {block.sectionTitle && <h2 className={styles.SArticleBlockHeaderTitle}>{block.sectionTitle}</h2>}
                    <div className={styles.SSocialMediaLabel}>Folg oss:</div>
                    <FilmwebLink className={styles.SSocialMediaLink} to="https://www.facebook.com/filmweb.no" rel="noopener noreferrer"><SomeFacebookSquareLogoSvg className={styles.fbSocMedia} /></FilmwebLink>
                    <FilmwebLink className={styles.SSocialMediaLink} to="https://www.instagram.com/filmwebno/" rel="noopener noreferrer"><SomeInstagramSquareLogoSvg className={styles.instaSocMedia} /></FilmwebLink>
                    <FilmwebLink className={styles.SSocialMediaLink} to="https://www.tiktok.com/@filmweb.no" rel="noopener noreferrer"><SomeTikTokLogoSvg className={styles.tiktokSocMedia} /></FilmwebLink>
                </div>
                <div className={styles.SArticlesContainer}>
                    {block.articles?.map((art, index) => <ImageTitle key={art._id}
                        className={styles.SImageTitle}
                        document={art as (IFilmnytt | IFilmomtale)}
                        forcedAspect={ASPECT_2_1}
                        sizes={SIZES}
                        themeValue={block[`themes${index}`] as (ThemeValues | undefined)}
                        isContentAd={isAdContent(art)}
                        contentAdLabelPlacementMobile="bottom"
                        useSectionTitle
                    />)}
                </div>
            </div>
            <VerticalArticleList className={styles.SVerticalArticleList} block={block.layouts?.[0]!} sponsorClickUrl={sponsorClickUrl} sponsorTopImageDesktop={sponsorTopImageDesktop} />
        </div>
    </>;
}
//#endregion
